import { WidgetDefinition } from '../models/WidgetDefinition';

export const alarmsTableWidgetDefinition: WidgetDefinition = {
    baseType: 'AlarmsTable',
    group: 'Charts',
    hasImage: true,
    highlights: ['Alarms that are raised during selected period of time', 'You can select alarms according to severity, categories or groups'],
    icon: 'fa-table',
    sortingOrder: 1500,
    title: 'Alarms table',
    type: 'AlarmsTable'
};